import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { EnrichedPack } from 'src/app/shared/model/pack';

@Component({
  selector: 'app-pack-selector',
  imports: [CommonModule, LucideAngularModule, TranslocoModule],
  templateUrl: './pack-selector.component.html',
})
export class PackSelectorComponent {
  @Input() packList: EnrichedPack[] = [];
  private _selectedPack: EnrichedPack | null = null;

  @Input()
  get selectedPack(): EnrichedPack | null {
    return this._selectedPack;
  }
  set selectedPack(pack: EnrichedPack | null) {
    this._selectedPack = pack;

    this.selectedItemIndex = pack
      ? this.packList.findIndex((p) => p.id === pack.id)
      : undefined;
  }
  @Output() selectedPackChange = new EventEmitter<EnrichedPack | null>();

  selectedItemIndex?: number;

  handleClick(index: number) {
    const item = this.packList[index];
    this.selectedItemIndex = index;
    this._selectedPack = item;
    this.selectedPackChange.emit(item);
  }

  isSelected(index: number) {
    return this.selectedItemIndex === index;
  }
}
